import React from 'react'
import SaleHistories from './SaleHistory';
import { SHOP_SETTING_KEY } from '../../../const';
import SaleHistoryDetailList from './SaleHistoryDetailList';

function SaleHistory() {
    const { shippingCost } = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
    return (
        <>
            {
                shippingCost ? (
                    <SaleHistoryDetailList />
                ) : (
                    <SaleHistories />
                )
            }
        </>
    )
}

export default SaleHistory